export class AuthorizationExpiredEvent {}
